import React from 'react'
import PackagePricePerMealPerPerson from '../PackagePricePerMealPerPerson';
import PackagePrice from '../PackagePrice';
import ProfileFarmer from '../ProfileFarmers';
import ProfileBuyer from '../ProfileBuyer';
import AnimalFill from '../AnimalFill';
import AnimalTag from '../AnimalTag';
import Image from '../Image'
import Slider from '../Slider'
import { Link } from 'react-router-dom';
import {currentLang, productURL} from '../../../utils/functions';
import {upperFirst, isNil} from 'lodash';
//import parse from 'html-react-parser';
//import img2 from '../../../assets/img/meat.jpg';
import { useTranslation } from 'react-i18next';
import W from '../Word';

const ProductCard = ({data}) => {
    const { t } = useTranslation();

    return (
        <div className={"package__item package--" + data.shop_brand_slug + (data.is_organic == 1 || data.is_demeter == 1 ? " package--bio" : "") + (data.is_special == 1 ? " package--special" : "") + (data.is_highlight == 1 ? " package--highlight" : "") + (data.is_msc == 1 ? " package--msc" : "") + (" " + currentLang())}>

            <div className="package__title">
              <a href={productURL(t('menu.products'), data.slug, data.shop_brand_slug)}>
                <h4 className="heading heading--h4 text-center">{data.title}
                  {(data.is_organic == 1 || data.is_demeter == 1) &&
                    <span className="text--green bio"><W>general.organic</W></span>
                  }
                  {(data.is_special == 1) &&
                    <span className="text--red special"><W>product.special</W></span>
                  }
                </h4>
              </a>
              <div className="package__info">
                <ul className="list list--no-list text-center">
                  {isNil(data.meatcut_pieces_suffix) &&
                    <li>{data.shop_package_product_count} <W>product.differentmeatcuts</W></li>
                  }
                  {!isNil(data.meatcut_pieces_suffix) &&
                    <li>{data.shop_package_product_count} {data.meatcut_pieces_suffix}</li>
                  }
                  <li>{parseInt(data.shop_package_total_meals_for_person)} <W>product.meals</W>  /  {data.shop_package_frontend_size}</li>
                  <li>{data.additional_info}</li>
                </ul>
              </div>
            </div>

            <div className="percentage__box">
                <a href={productURL(t('menu.products'), data.slug, data.shop_brand_slug)}>
                  <AnimalFill
                      percentage={data.shop_product_percentage_sold}
                      animal={data.shop_brand_slug}
                      category_slug={data.shop_category_slug}

                  />

                  <AnimalTag
                    country={data.shop_animal_nr_prefix}
                    amount={data.shop_animal_nr}
                  />
                </a>
            </div>

            <div className="product-info">
              <div className="item">
                  <ProfileFarmer
                      name={data.farmer_name}
                      title={data.farmer_title}
                      body={data.farmer_summary}
                      location={data.farmer_location}
                      image={data.farmer_image_url}
                      breeds={data.shop_animal_name}
                      link={data.farmer_slug}
                      earnumber={data.shop_animal_nr}
                      isnew={data.farmer_is_new}
                      animal={data.shop_brand_slug}
                  />
              </div>
              <div className="item">
                  <ProfileBuyer
                      totalBuyers={data.shop_product_buyer_count}
                      totalPackages={data.shop_product_total_package_available}
                      soldPercentage={data.shop_product_percentage_sold}
                  />
              </div>
              <div className="item meal-price d-none">
                <PackagePricePerMealPerPerson
                  value={data.shop_package_price_per_meals && data.shop_package_price_per_meals.toFixed(2)}
                  prevPrice={data.previous_price}
                  mealsPerPerson={data.shop_package_total_meals_for_person}
                />
              </div>
              <div className="item full-price">
                <PackagePrice
                  fullPrice={data.shop_package_price && data.shop_package_price.toFixed(2)}
                  mealPrice={data.shop_package_price_per_meals && data.shop_package_price_per_meals.toFixed(2)}
                  prevPrice={data.previous_price}
                />
              </div>
            </div>
            <div className="package__action align-self-center">

                {data.shop_product_stock_status != "instock" &&
                  <Link to={productURL(t('menu.products'), data.slug, data.shop_brand_slug)} className="btn btn--dark btn--full"><W>shop.status.{data.shop_product_stock_status}</W></Link>
                }
                {data.shop_product_stock_status == "instock" &&
                  <Link to={productURL(t('menu.products'), data.slug, data.shop_brand_slug)} className="btn btn--secondary btn--full"><W>shop.status.{data.shop_product_stock_status}_view</W></Link>
                }
            </div>
            <div className="package__slider">
              {data.main_slider &&
                <Slider data={data.main_slider} sliderType="product" options={{notitle:true}} />
              }
            </div>
        </div>
    )
}

export default ProductCard
